import SelectLoader, {LoaderFn} from "@/lib/components/VSelectV2/SelectLoader";
import DataGridLoader, {ServiceMethod} from "@/lib/components/VDataGridV2/DataGridLoader";

/**
 * Фабрика лоадеров данных.
 *
 * @example
 * Loader.select<Order>(({ seller }) => StoresService.getList({ partnerId: seller.id }))
 *   .dependsOn({ seller: () => this.localOrder.seller })
 *   .preloadOnFocus()
 *
 * @example
 * Loader.dataGrid(TendersService.getListPaginated)
 *   .useExtraParams({ isDeleted:false} )
 *   .useReactiveSource(() => ({ tabId: this.tabId }))
 */
export default class Loader {

  /** Источник опций для VSelect. */
  static select<T = any>(dataSource: LoaderFn<T> | any[]): SelectLoader<T> {
    return new SelectLoader<T>(dataSource);
  }

  /** Источник данных для VDataGridV2. */
  static dataGrid<TParams = any, TEntity = any>(serviceMethod: ServiceMethod<TParams, TEntity>): DataGridLoader<TParams, TEntity> {
    return new DataGridLoader<TParams, TEntity>(serviceMethod);
  }
}